/** What a screen shows for a code no vocabulary knows — translated, never the stored text. */
export const UNCATALOGUED = {
    pt: 'Valor não catalogado',
    en: 'Uncatalogued value',
    es: 'Valor no catalogado',
    it: 'Valore non catalogato',
};
/** What a screen shows for an absent value. */
export const NO_VALUE = '—';
/** What a screen shows for a refusal whose reason no vocabulary knows. */
export const UNKNOWN_REASON = {
    pt: 'O servidor recusou a operação.',
    en: 'The server refused the operation.',
    es: 'El servidor rechazó la operación.',
    it: 'Il server ha rifiutato l’operazione.',
};
/** The HTTP class a status stands for (a bare refusal with no reason code). */
const STATUS_CLASS = { 401: 'UNAUTHORIZED', 403: 'FORBIDDEN', 404: 'NOT_FOUND', 409: 'CONFLICT', 429: 'RATE_LIMITED', 503: 'SERVICE_UNAVAILABLE' };
export function indexVocabularies(vocabularies) {
    const byId = new Map();
    for (const v of vocabularies) {
        if (byId.has(v.id))
            throw new Error(`duplicate vocabulary id: ${v.id}`);
        byId.set(v.id, v);
    }
    const reasons = new Map();
    for (const v of vocabularies) {
        if (!v.id.startsWith('problem.'))
            continue;
        for (const [code, labels] of Object.entries(v.labels))
            if (!reasons.has(code))
                reasons.set(code, labels);
    }
    const fill = (text, vars) => vars === undefined ? text : text.replace(/\{(\w+)\}/g, (m, k) => (Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : m));
    const entry = (id, code) => code === null || code === undefined || code === '' ? undefined : byId.get(id)?.labels?.[code];
    return {
        all: vocabularies,
        has: (id, code) => entry(id, code) !== undefined,
        label: (id, code, lang, vars) => {
            if (code === null || code === undefined || code === '')
                return NO_VALUE;
            return fill((entry(id, code) ?? UNCATALOGUED)[lang], vars);
        },
        hasReason: (code) => code !== null && code !== undefined && reasons.has(code),
        refusal: (surface, error, lang, vars) => {
            const code = error.reasonCode ?? error.detail;
            const own = entry(surface, code);
            if (own !== undefined)
                return fill(own[lang], vars ?? error.params);
            if (code !== undefined && reasons.has(code))
                return fill(reasons.get(code)[lang], vars ?? error.params);
            for (const cls of [error.code, error.status !== undefined ? STATUS_CLASS[error.status] : undefined]) {
                const byClass = entry(surface, cls);
                if (byClass !== undefined)
                    return fill(byClass[lang], vars);
            }
            return undefined;
        },
        reason: (code, lang, vars) => fill(((code !== null && code !== undefined ? reasons.get(code) : undefined) ?? UNKNOWN_REASON)[lang], vars),
    };
}
//# sourceMappingURL=lookup.js.map